export const FIRST_NAME_TEST_ID = "first-name";
export const LAST_NAME_TEST_ID = "last-name";
export const COMPANY_TEST_ID = "company";
export const IS_COMPANY_CHECKBOX_TEST_ID = "is-company";
export const VAT_TEST_ID = "vat";
export const PHONETIC_FIRST_NAME_TEST_ID = "phonetic-first";
export const PHONETIC_LAST_NAME_TEST_ID = "phonetic-last";
export const ADDRESS_TEST_ID = "address";
export const ADDRESS_LOOKUP_TEST_ID = "address-lookup";
export const ADDRESS_LOOKUP_OPTION_TEST_ID = "address-lookup-option";
export const ADDITIONAL_ADDRESS_TEST_ID = "additional-address";
export const ZIP_CODE_TEST_ID = "zip-code";
export const CITY_TEST_ID = "city";
export const COUNTRY_TEST_ID = "country";
export const REGION_TEST_ID = "region";
export const DISTRICT_TEST_ID = "district";
export const SALUTATION_TEST_ID = "salutation";
export const LANDMARK_TEST_ID = "landmark";
export const REGION_MODAL_TEST_ID = "region-modal";
export const REGION_DROPDOWN_TEST_ID = "region-dropdown";
export const REGION_DROPDOWN_BUTTON_TEST_ID = "region-dropdown-button";
export const REGION_BUTTON_TEST_ID = "region-button";
export const DELIVERY_SUBMIT_BUTTON_TEST_ID = "delivery-submit";
export const DELIVERY_STEP_FORM_TEST_ID = "delivery-step-form";
export const DELIVERY_INSTRUCTIONS = "delivery-instructions";
export const DELIVERY_DATE = "delivery-date";
export const DELIVERY_TIME = "delivery-time";
export const SAME_BILLING_ADDRESS_CHECKBOX = "same-billing-address";
export const MISSING_HOUSE_NUMBER_MODAL_TEST_ID = "missing-house-number-modal";
export const MISSING_HOUSE_NUMBER_EDIT_BUTTON_TEST_ID = "missing-house-number-edit";
export const MISSING_HOUSE_NUMBER_CONFIRM_BUTTON_TEST_ID = "missing-house-number-confirm";
